import { t } from 'localization'
import { FC } from 'react'
import { Button } from 'shared/components/Button'
import Modal from 'shared/components/Modal'
import { colors, fonts } from 'shared/lib'
import styled from 'styled-components'

const TP = 'errors.components.errorModal'

interface ILoginErrorProps {
  isOpen: boolean
  message: string
  buttonText?: string
  titleText?: string
  onClose?()
  onSubmit()
}

const Content = styled.div`
  background-color: ${colors.FC2_WHITE};
  border-top: 1px solid ${colors.FC2_LIGHTEST_GREY};
  padding: 20px;
  width: 100%;
`

const Header = styled.h1`
  ${fonts.SUBTITLE_2}
  margin: 0 0 10px 0;
`

const Description = styled.div`
  ${fonts.BODY_TEXT}
`

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`

export const ErrorModal: FC<ILoginErrorProps> = (props) => {
  const { isOpen, titleText, buttonText, onClose, message, onSubmit } = props

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Content>
        <Header>{!!titleText ? titleText : t(`${TP}.header`, 'Error')}</Header>
        <Description>{message}</Description>
        <Actions>
          <Button
            buttonType="primary1"
            dataTestid="error-modal-dismiss-button"
            $fill
            onClick={onSubmit}
            type="submit"
          >
            {!!buttonText ? buttonText : t(`${TP}.retry`, 'Retry')}
          </Button>
        </Actions>
      </Content>
    </Modal>
  )
}

export default ErrorModal
